import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BrowserModule } from '@angular/platform-browser';
import { FormsModule } from '@angular/forms';
import { NgSelectModule } from '@ng-select/ng-select';

import { CoreModule } from '../core/core.module';
import { WalkaroundQuestionsRoutingModule } from './walkaround-questions-routing.module';
import { WalkaroundQuestionsComponent } from './pages/walkaround-questions/walkaround-questions.component';
import { WalkaroundQuestionsNewComponent } from './pages/walkaround-questions-new/walkaround-questions-new.component';
import { WalkaroundQuestionsEditComponent } from './pages/walkaround-questions-edit/walkaround-questions-edit.component';
import { WalkaroundQuestionFormComponent } from './partials/walkaround-question-form/walkaround-question-form.component';

@NgModule({
  declarations: [
    WalkaroundQuestionsComponent,
    WalkaroundQuestionsNewComponent,
    WalkaroundQuestionsEditComponent,
    WalkaroundQuestionFormComponent,
  ],
  imports: [
    CommonModule,
    BrowserModule,
    FormsModule,
    CoreModule,
    NgSelectModule,
    WalkaroundQuestionsRoutingModule,
  ],
})
export class WalkaroundQuestionsModule { }
